<template>
  <div>
    <p class="has-text-weight-semibold mb-4">
      {{ $texts('logged_in', 'Sie sind eingeloggt.') }}
    </p>
    <a class="button is-danger" href="/user/logout">
      {{ $texts('logout', 'Abmelden') }}</a
    >
  </div>
</template>

<script setup lang="ts">
const { $texts } = useNuxtApp()
</script>
